import React from 'react';

import queries from "../../../queries";
import SpecificCellPreview from "./SpecificCellPreview";
import {RankingCell} from '@treeosk/common';

class RankingCellPreview extends React.Component {

  render() {
    const { cell } = this.props;

    return (
      <SpecificCellPreview
        cell={cell}
        query={queries.cells.quizz.get}
        renderingCondition={(textCell) => !!textCell.text_data}
      >
        {(quizzCell) =>
          <RankingCell preview={true} cell={quizzCell} />
        }
      </SpecificCellPreview>
    );
  }

}

export default RankingCellPreview;